export default __webpack_public_path__ + "static/media/logo-oegbv.029fe238.svg";